import { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../state/actions";
import ReactTooltip from "react-tooltip";
import CheckboxField from "../../shared/checkboxField/CheckboxField";
import CustomButton from "../../shared/customButton/CustomButton";
import InputField from "../../shared/inputField/InputField";
import PaypalButtons from "../checkoutDetail/paypalButtons/PaypalButtons";
import PaypalForm from "../checkoutDetail/paypalForm/PaypalForm";
import PaypalMessages from "../checkoutDetail/paypalMessages/PaypalMessages";
import ModalConfirm from "../../shared/modalConfirm/ModalConfirm";
import debounce from "../../../utils/debounce";
//import { fbqIniziaAcquisto } from "../../../fbq/fbq";

const RiepilogoCarrello = ({
  isButtonSending,
  isPaypal = false,
  currentPaymentMethodId = false,
  toggleWarningAlert = () => {},
  onPaypalSubmit = () => {},
  onPaymentSubmit = () => {},
  onCardSubmit = () => {},
}) => {
  const dispatch = useDispatch();
  const [clientToken, setClientToken] = useState(null);
  const [isclientTokenLoaded, setClientTokenLoaded] = useState(false);
  const tokenCarrello = useSelector((state) => state.user.token_id);
  const currentPage = useSelector((state) => state.currentPage);
  const order = useSelector((state) => state.order);
  const shippingCountries = useSelector(
    (state) => state.checkout.shippingCountries
  );
  const user = useSelector((state) => state.user);
  const checkout = useSelector((state) => state.checkout);
  const routeName = useSelector((state) => state.currentPage.routeName);
  const promotion = useSelector((state) => state.promotion);
  const fasiCarrelloTranslation = useSelector(
    (state) => state.translations.fasiCarrello
  );

  const carrelloTranslation = useSelector(
    (state) => state.translations.carrello
  );
  const riepilogoCarrelloTranslation = useSelector(
    (state) => state.translations.riepilogoCarrello
  );
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );
  const erroriFormTranslation = useSelector(
    (state) => state.translations.erroriForm
  );

  const siteParams = useSelector((state) => state.siteParams);
  const soglia_ambassador = parseFloat(siteParams?.soglia_ambassador);
  const credito_ambassador = parseFloat(siteParams?.credito_ambassador);
  const fascia_acquisto_ambassador = parseFloat(
    siteParams?.fascia_acquisto_ambassador
  );
  const fascia_credito_ambassador = parseFloat(
    siteParams?.fascia_credito_ambassador
  );

  // local state
  const [calcolaspedizione, setCalcolaSpedizione] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(
    order.selectedCountryId
  );
  const [selectedCountryName, setSelectedCountryName] = useState("Italia");
  const [aliquotaIVA, setAliquotaIVA] = useState(order.aliquotaIVA);
  const [aliquotaIVADesc, setAliquotaIVADesc] = useState(
    order.descrizioneAliquotaIVA
  );
  const [subtotalCartVAT, setSubtotalCartVAT] = useState(order.subtotalCartVAT);
  const [shippingCost, setShippingCost] = useState(0);
  const [shippingVATCost, setShippingVATCost] = useState(0);
  const [totalCart, setTotalCart] = useState(order.totalCart);
  const [totalCartByCap, setTotalCartByCap] = useState(order.totalCart);
  const [totalToShow, setTotalToShow] = useState(0);
  const [couponSconto, setCouponSconto] = useState("");
  const [isCouponSending, setIsCouponSending] = useState(false);
  const [selectedCAP, setSelectedCAP] = useState(null);
  const [isNoShipping, setIsNoShipping] = useState(null);
  const [couponAmbassador, setCouponAmbassador] = useState(0);

  useEffect(() => {
    console.log("Riepilogo Carrello");
    setSubtotalCartVAT(order.subtotalCartVAT);
    setShippingCost(order.totalShipping);
    setShippingVATCost(order.totalShippingVAT);
    setTotalCart(order.totalCart);
    setSelectedCountry(order.selectedCountryId);
    setAliquotaIVA(order.aliquotaIVA);
    setAliquotaIVADesc(order.descrizioneAliquotaIVA);

    // se cambio da shipping a noshipping aggiorno stato locale
    if (isNoShipping !== order.isNoShipping) {
      // fix anteprima totale carrello quando passo da ritiro in sede a spedizione 03/03/2022
      isNoShipping !== order.isNoShipping
        ? setTotalToShow(order.totalCart)
        : setTotalToShow(totalCart);
      setTotalCart(totalToShow);
    }

    order.isNoShipping === true
      ? setCalcolaSpedizione("ritiroinsede")
      : setCalcolaSpedizione("calcolaspedizione");
    setIsNoShipping(order.isNoShipping);

    // messaggio inserimento coupon?
    if (isCouponSending) {
      ModalConfirm({
        titleToShow: erroriFormTranslation.coupontitolo.itemName,
        messageToShow: order.message,
        isShowConfirmButton: false,
        isShowCanceButton: false,
        isTimerModal: true,
      });
      setIsCouponSending(false);
    }

    // se il calcolo spedizione da CAP è cambiato mostro i nuovi valori all'utente (solo anteprima)
    if (
      order?.capSelected !== undefined &&
      selectedCAP !== null &&
      order?.capSelected === selectedCAP
    ) {
      showShippingFromCap();
    }

    if (!isclientTokenLoaded) {
      console.log("This should called once");
      setClientTokenLoaded(true);
      (async () => {
        const response = await (await fetch(`api/paypalClientToken/`)).json();
        setClientToken(response?.client_token || response?.clientToken);
      })();
    }
  }, [
    order.totalCart,
    order.isNoShipping,
    order.dataUpdate,
    order?.shippingCostCAP,
    totalToShow,
    user.userData?.coupons_unused,
  ]);

  // passa da spedizione a ritiro in sede
  const onCalcolaSpedizioneChange = (event) => {
    //console.log(event);
    setCalcolaSpedizione(event);

    // nascondo eventuale warning
    toggleWarningAlert(false);

    // chiamo action creator per aggiornare ordine con no shipping (ritiro in sede) o con costo spedizione
    if (event !== calcolaspedizione) {
      dispatch(
        allActions.cartDetailActions.sendNoShipping(
          currentPage.currentLang,
          user?.userData?.id,
          order.selectedCountryRealId,
          tokenCarrello,
          event
        )
      );
    }

    console.log("onCalcolaSpedizioneChange order.totalCart", order.totalCart);
  };

  // recupero cap e nazione per le spedizioni all'estero
  const onSpedizioneCapChange = debounce(function (event) {
    const selectedCountryName =
      shippingCountries[selectedCountry]?.shippingCountry;
    const selectedCountryRealId = shippingCountries[selectedCountry]?.id;
    const capValue = event.floatValue;
    console.log(selectedCountryName, capValue, selectedCountryRealId);

    // salvo localmente il cap
    setSelectedCAP(capValue);

    if (
      selectedCountryName === "Italia" ||
      selectedCountryName === "France" ||
      selectedCountryName === "Greece"
    ) {
      dispatch(
        allActions.cartDetailActions.shippingFromCap(
          currentPage.currentLang,
          user?.userData?.id,
          selectedCountryRealId,
          tokenCarrello,
          capValue
        )
      );
    }
  }, 1000);

  // questa funzione viene chiamata in risposta alla ricerca per CAP
  const showShippingFromCap = () => {
    //setSelectedCountry(event.target.value);
    // resetto nazione locale
    const nazioneId = Object.keys(checkout.shippingCountries).filter(
      (itemId) => {
        const countryItem = checkout.shippingCountries[itemId];
        return countryItem.id === order.shippingCountryCAP.id;
      }
    )[0];
    setSelectedCountry(nazioneId);

    // recupero nazione italia nel caso di utente loggato come azienda italiana
    const italiaId = Object.keys(checkout.shippingCountries).filter(
      (itemId) => {
        const countryItem = checkout.shippingCountries[itemId];
        return countryItem.id === 36;
      }
    )[0];
    const countryITA = checkout.shippingCountries[italiaId];

    // anteprima costo spedizione senza iva
    setShippingCost(order.shippingCostCAP);

    // calcolo iva imponibile in base a nazione di spedizione (N.B se sono loggato come azienda italiana, l'iva è sempre al 22%!) --> nel caso di azienda estera non ricalcolo l'iva perchè è a 0!!!
    let aliquotaIVANuova = 0;
    let aliquotaIVADescNuova = "";
    let newShippingCostVAT = 0;
    let ivaPerSpedizione = 0;

    // utente loggato come privato o azienda
    if (user?.userData?.vat_disabled === 0) {
      aliquotaIVANuova =
        user.userData?.meta_data?.partitaiva &&
        user.userData?.meta_data.nazione === "36"
          ? countryITA.aliquotaIVA
          : order.shippingCountryCAP.aliquotaIVA;
      setAliquotaIVA(aliquotaIVANuova);

      aliquotaIVADescNuova =
        user.userData?.meta_data?.partitaiva &&
        user.userData?.meta_data.nazione === "36"
          ? "IVA " + countryITA.descrizioneEstesa
          : "IVA " + order.shippingCountryCAP.descrizioneEstesa;
      setAliquotaIVA(aliquotaIVANuova);
      setAliquotaIVADesc(aliquotaIVADescNuova);
      newShippingCostVAT = (order.subtotalCart / 100) * aliquotaIVANuova;
      setSubtotalCartVAT(newShippingCostVAT);

      // iva spedizione
      ivaPerSpedizione =
        (order.shippingCostCAP / 100) * order.shippingCountryCAP.aliquotaIVA;
      setShippingVATCost(ivaPerSpedizione);
    } else {
      // utente non ancora loggato oppure utente loggato con vat_disabled = 1
      console.log("non loggato oppure utente loggato con vat_disabled = 1");
      aliquotaIVANuova = order.shippingCountryCAP.aliquotaIVA;
      aliquotaIVADescNuova = order.shippingCountryCAP.descrizioneEstesa;
      setAliquotaIVA(aliquotaIVANuova);
      setAliquotaIVADesc(aliquotaIVADescNuova);
      newShippingCostVAT = (order.subtotalCart / 100) * aliquotaIVANuova;
      setSubtotalCartVAT(newShippingCostVAT);

      // iva spedizione
      ivaPerSpedizione =
        (order.shippingCostCAP / 100) * order.shippingCountryCAP.aliquotaIVA;
      setShippingVATCost(ivaPerSpedizione);
    }

    // totale in base a IVA spedizione
    const newTotal =
      order.subtotalCart +
      newShippingCostVAT +
      parseFloat(order.shippingCostCAP) +
      parseFloat(ivaPerSpedizione);

    setTotalCart(newTotal);
    setTotalCartByCap(newTotal);
  };

  // cambio paese da select Nazione con anteprima calcolo spedizione
  const onCountryChange = (event) => {
    const newSelectedCountry = checkout.shippingCountries[event.target.value];
    const nazioneId = Object.keys(checkout.shippingCountries).filter(
      (itemId) => {
        const countryItem = checkout.shippingCountries[itemId];
        return countryItem.id === 36;
      }
    )[0];
    const countryITA = checkout.shippingCountries[nazioneId];
    //console.log(event.target.value);
    setSelectedCountry(event.target.value);
    setSelectedCountryName(newSelectedCountry.shippingCountry);
    setShippingCost(newSelectedCountry.shippingCostByWeight);
    //console.log(newSelectedCountry.shippingCostByWeight);

    // se newSelectedCountry.shippingCostByWeight = 0 vuol dire che non ho un costo di spedizione quindi mostro l'avviso in CartDetail.jsx (se non esiste una promozione trasporto gratuito attiva)
    newSelectedCountry.shippingCostByWeight === 0 &&
    promotion?.sogliaCarrello === undefined
      ? toggleWarningAlert(true)
      : toggleWarningAlert(false);

    // calcolo iva imponibile in base a nazione di spedizione (N.B se sono loggato come azienda italiana, l'iva è sempre al 22%!) --> nel caso di azienda estera non ricalcolo l'iva perchè è a 0!!!
    let aliquotaIVANuova = 0;
    let aliquotaIVADescNuova = "";
    let newShippingCostVAT = 0;
    let ivaPerSpedizione = 0;

    // utente loggato come privato o azienda
    if (user?.userData?.vat_disabled === 0) {
      aliquotaIVANuova =
        user.userData?.meta_data?.partitaiva &&
        user.userData?.meta_data.nazione === "36"
          ? countryITA.aliquotaIVA
          : newSelectedCountry.aliquotaIVA;

      aliquotaIVADescNuova =
        user.userData?.meta_data?.partitaiva &&
        user.userData?.meta_data.nazione === "36"
          ? "IVA " + countryITA.descrizioneEstesa
          : "IVA " + newSelectedCountry.descrizioneEstesa;
      setAliquotaIVA(aliquotaIVANuova);
      setAliquotaIVADesc(aliquotaIVADescNuova);
      newShippingCostVAT = (order.subtotalCart / 100) * aliquotaIVANuova;
      setSubtotalCartVAT(newShippingCostVAT);

      // iva spedizione
      ivaPerSpedizione =
        user.userData?.meta_data?.partitaiva &&
        user.userData?.meta_data.nazione === "36"
          ? countryITA.shippingCostVATByWeight
          : newSelectedCountry.shippingCostVATByWeight;
      setShippingVATCost(ivaPerSpedizione);
    } else {
      // utente non ancora loggato oppure utente loggato con vat_disabled = 1
      console.log(
        "non loggato oppure utente loggato con vat_disabled = 1",
        newSelectedCountry
      );
      aliquotaIVANuova = newSelectedCountry.aliquotaIVA;

      aliquotaIVADescNuova = newSelectedCountry.descrizioneEstesa;
      setAliquotaIVA(aliquotaIVANuova);
      setAliquotaIVADesc(aliquotaIVADescNuova);
      newShippingCostVAT = (order.subtotalCart / 100) * aliquotaIVANuova;
      setSubtotalCartVAT(newShippingCostVAT);

      // iva spedizione
      ivaPerSpedizione = newSelectedCountry.shippingCostVATByWeight;
      setShippingVATCost(ivaPerSpedizione);
    }

    // totale in base a IVA spedizione
    const newTotal =
      order.subtotalCart +
      newShippingCostVAT +
      parseFloat(newSelectedCountry.shippingCostByWeight) +
      parseFloat(ivaPerSpedizione);

    setTotalCart(newTotal);
  };

  // cambio stato locale coupon
  const onCouponScontoChange = (event) => {
    setCouponSconto(event.target.value);
  };

  // cambio stato locale coupon
  const onCouponAmbassadorAdd = (event, couponAmbassadorValue) => {
    event.preventDefault();
    if (couponAmbassadorValue !== "") {
      setIsCouponSending(true);
      // invio coupon a API
      dispatch(
        allActions.cartDetailActions.postCouponAmbassadorAdd(
          currentPage.currentLang,
          user?.userData?.id,
          tokenCarrello,
          couponAmbassadorValue
        )
      );
    }
  };

  // aggiunta coupon
  const onCouponSend = () => {
    if (couponSconto !== "") {
      setIsCouponSending(true);

      // invio coupon a API
      dispatch(
        allActions.cartDetailActions.postCouponAdd(
          currentPage.currentLang,
          user?.userData?.id,
          tokenCarrello,
          couponSconto
        )
      );
    }
  };

  const onPaymentSend = (event) => {
    event.preventDefault();
    //console.log(event);
    console.log("onpaymentSend");
    // chiamo funzione di PaymentDetail per mostrare il warning se necessario
    onPaymentSubmit();
  };

  const onIniziaAcquisto = (event) => {
    // fbq product Detail
    /* const fbqSuffix = `pixelfacebook${currentPage.currentLang}`;
    const currentFBQTAG = siteParams[fbqSuffix];
    fbqIniziaAcquisto({
      isFbqEnabled: currentFBQTAG !== null ? true : false,
    });*/
  };

  const onAskDeleteCoupon = (codiceCoupon) => {
    ModalConfirm({
      titleToShow: carrelloTranslation.modalTitoloRimozioneCoupon.itemName,
      messageToShow: `${carrelloTranslation.modalConfermaRimozioneCoupon.itemName} <b>${codiceCoupon}</b>?`,
      textConfirmButton: genericheTranslation.conferma.itemName,
      textCancelButton: genericheTranslation.annulla.itemName,
      onClickHandler: () => onGoToDeleteCoupon(codiceCoupon),
    });
  };

  const onGoToDeleteCoupon = (codiceCoupon) => {
    // chiamo action creator per aggiornare store
    dispatch(
      allActions.cartDetailActions.deleteCoupon(
        currentPage.currentLang,
        user?.userData?.id,
        order.selectedCountryRealId,
        tokenCarrello,
        codiceCoupon
      )
    );
  };

  if (checkout?.shippingCountries === undefined) {
    return <div></div>;
  }

  const shippingCostByWeight =
    shippingCost > 0 && order.isNoShipping === false ? shippingCost : 0;
  const shippingCostVATByWeight =
    shippingVATCost > 0 && order.isNoShipping === false ? shippingVATCost : 0;

  const elencoPaesiSpedizione = checkout.shippingCountries.map(
    (item, index) => {
      return (
        <option key={item.id} value={index}>
          {item.shippingCountry}
        </option>
      );
    }
  );

  // disabilito i label del calcolo spedizione o ritiro in sede se il carrello è vuoto
  const isLabelDisabled =
    order.isNoShipping === null &&
    "pointer-events-none opacity-60 cursor-default";
  const messageRitiroInSede =
    order.isNoShipping === true &&
    riepilogoCarrelloTranslation.ritiroinsede.itemName;

  // possabilità di selezionare ritiro in sede (è possibile solo nella sezione carrello)
  const selezionaSpedizioneORitiroInSede = routeName === "cartDetail" && (
    <div className="text-ribola-congress-blue flex xl:justify-between items-center mt-8">
      <i className="fal fa-shipping-fast text-4xl xl:text-3xl mr-2"></i>
      <div
        className={`flex flex-col sm:flex-row xl:flex-col 3xl:flex-row ${isLabelDisabled}`}
      >
        <CheckboxField
          checkboxType="radio"
          checkboxLabel={
            riepilogoCarrelloTranslation.spedizionicalcola.itemName
          }
          checkboxLabelStyle="flex items-center text-sm mb-3 sm:mb-0"
          checkboxName="calcolaspedizione"
          checkboxHandlerFunction={() =>
            onCalcolaSpedizioneChange("calcolaspedizione")
          }
          isChecked={order.isNoShipping === false ? true : false}
          isDisabled={
            order.isNoShipping === null || order.totalItems === 0 ? true : false
          }
          checkboxStyle="border-2 text-ribola-congress-blue border-ribola-congress-blue mr-3 cursor-pointer"
          direction="right"
        />
        <CheckboxField
          checkboxType="radio"
          checkboxLabel={riepilogoCarrelloTranslation.ritiroinsede.itemName}
          checkboxLabelStyle="flex items-center text-sm"
          checkboxName="calcolaspedizione"
          checkboxHandlerFunction={() =>
            onCalcolaSpedizioneChange("ritiroinsede")
          }
          isChecked={order.isNoShipping === true ? true : false}
          isDisabled={
            order.isNoShipping === null || order.totalItems === 0 ? true : false
          }
          checkboxStyle="border-2 text-ribola-congress-blue border-ribola-congress-blue mr-3 cursor-pointer"
          direction="right"
        />
      </div>
    </div>
  );

  const isButtonDisabled = order.totalItems === 0 ? true : false;
  const isButtonConcludiDisabled =
    order.totalItems === 0 ||
    order.paymentId === null ||
    order.paymentId === 0 ||
    (order.addressId === 0 &&
      (order.addressId === null || order.isNoShipping === false))
      ? true
      : false;
  const isSelectShippingDisabled =
    order.isNoShipping === true || order.totalItems === 0 ? true : false;

  // mostro calcolo spedizione per paese solo nella pagina carrello (nella pagina pagamento posso solamente scegliere ritiro in sede o spedizione)
  const calcoloSpedizione = routeName === "cartDetail" && (
    <Fragment>
      <span
        dangerouslySetInnerHTML={{
          __html: riepilogoCarrelloTranslation.calcolaspedizioniestero.itemName,
        }}
      />
      <div className="relative mt-3">
        <select
          onChange={onCountryChange}
          value={selectedCountry}
          disabled={isSelectShippingDisabled}
          className="form-select appearance-none w-full bg-transparent border border-ribola-dove-gray focus:outline-none cursor-pointer font-opensanssemibold text-xl"
          style={{ textAlignLast: "center" }}
        >
          {elencoPaesiSpedizione}
        </select>
      </div>
    </Fragment>
  );

  // anteprima costo spedizione con CAP (al momento solo Italia, Francia e Grecia)
  const calcoloSpedizionePerCap = routeName === "cartDetail" &&
    !isSelectShippingDisabled &&
    (selectedCountryName === "Italia" ||
      selectedCountryName === "France" ||
      selectedCountryName === "Greece") && (
      <Fragment>
        <span
          className="block mt-3"
          dangerouslySetInnerHTML={{
            __html: riepilogoCarrelloTranslation.calcolaspedizionicap.itemName,
          }}
        />
        <div className="relative mt-3">
          <InputField
            inputType="number"
            inputName="capSpedizione"
            inputPlaceholder={
              riepilogoCarrelloTranslation.inseriscicap.itemName
            }
            inputMaxValue={99999}
            isNumberFormat={true}
            inputDecimalScale="none"
            inputThousandSeparator=""
            inputHandlerFunction={onSpedizioneCapChange}
            inputStyle="border border-ribola-dove-gray w-1/2 text-sm"
          />
        </div>
      </Fragment>
    );

  // tipo pulsante da mostrare per proseguire
  let buttonProsegui = "";
  if (routeName === "cartDetail") {
    if (user.isLogged) {
      buttonProsegui = (
        <CustomButton
          buttonLink={fasiCarrelloTranslation.spedizionePagamento.linkName}
          buttonRouteName={
            fasiCarrelloTranslation.spedizionePagamento.routeName
          }
          buttonName={riepilogoCarrelloTranslation.procediconpagamento.itemName.toUpperCase()}
          buttonOnClickFunction={onIniziaAcquisto}
          buttonStyle="iniziaAcquisto w-full flex justify-center items-center text-white text-center bg-ribola-amber hover:bg-ribola-web-orange transition duration-300 text-base 2xl:text-lg 3xl:text-xl font-opensanssemibold py-4 px-2 2xl:px-6 border-r-2 border-ribola-gallery-gray"
          isButtonDisabled={isButtonDisabled}
        />
      );
    } else {
      buttonProsegui = (
        <CustomButton
          buttonLink={fasiCarrelloTranslation.registrazione.linkName}
          buttonRouteName={fasiCarrelloTranslation.registrazione.routeName}
          buttonName={riepilogoCarrelloTranslation.procediconpagamento.itemName.toUpperCase()}
          buttonOnClickFunction={onIniziaAcquisto}
          buttonStyle="iniziaAcquisto w-full flex justify-center items-center text-white text-center bg-ribola-amber hover:bg-ribola-web-orange transition duration-300 text-base 2xl:text-lg 3xl:text-xl font-opensanssemibold py-4 px-2 2xl:px-6 border-r-2 border-ribola-gallery-gray"
          isButtonDisabled={isButtonDisabled}
        />
      );
    }
  } else if (routeName === "paymentDetail") {
    buttonProsegui = (
      <CustomButton
        buttonLink={fasiCarrelloTranslation.concludiOrdineFase.linkName}
        buttonRouteName={fasiCarrelloTranslation.concludiOrdineFase.routeName}
        buttonName={riepilogoCarrelloTranslation.procediconpagamento.itemName.toUpperCase()}
        buttonOnClickFunction={onPaymentSend}
        buttonStyle="w-full flex justify-center items-center text-white text-center bg-ribola-amber hover:bg-ribola-web-orange transition duration-300 text-base 2xl:text-lg 3xl:text-xl font-opensanssemibold py-4 px-2 2xl:px-6 border-r-2 border-ribola-gallery-gray"
        isButtonDisabled={false}
      />
    );
  } else if (routeName === "checkoutDetail") {
    if (isPaypal) {
      let fundingSource = "paypal";
      if (currentPaymentMethodId == 2) {
        fundingSource = "paypal";
      } else if (currentPaymentMethodId == 6) {
        fundingSource = "card";
      }

      buttonProsegui = (
        <>
          {clientToken &&
            (fundingSource == "paypal" ? (
              <>
                <PaypalButtons
                  clientToken={clientToken}
                  fundingSource={fundingSource}
                  onPaypalSubmit={onPaypalSubmit}
                />
              </>
            ) : (
              <PaypalForm
                clientToken={clientToken}
                fundingSource={fundingSource}
                onCardSubmit={onCardSubmit}
              />
            ))}
        </>
      );
    } else {
      buttonProsegui = (
        <InputField
          inputType="submit"
          inputValue={riepilogoCarrelloTranslation.pagaordine.itemName.toUpperCase()}
          inputStyle="w-full flex justify-center items-center text-white text-center bg-ribola-amber hover:bg-ribola-web-orange transition duration-300 text-lg 3xl:text-xl font-opensanssemibold py-4 px-2 2xl:px-6 border-r-2 border-ribola-gallery-gray cursor-pointer"
          showLabel={false}
          isSpinnerLoading={isButtonSending}
        />
      );
    }
  }
  // fine tipo pulsante da mostrare per proseguire

  // parte ambassadorcode
  let divCouponAmbassador = "";
  if (
    order?.totalItems > 0 &&
    order?.codiceCoupon === null &&
    (routeName === "cartDetail" || routeName === "paymentDetail") &&
    user.userData?.coupons_unused?.length > 0 &&
    order?.subtotalCart > fascia_acquisto_ambassador
  ) {
    let tmp1 = order?.subtotalCart / fascia_acquisto_ambassador;
    let tmp2 = Math.floor(tmp1);
    let tmp3 = user.userData?.coupons_unused.length;
    let tmp4 = Math.min(tmp2, tmp3);
    let couponAmbassadorValue = tmp4 * fascia_credito_ambassador;

    const perifrasi =
      routeName === "cartDetail" ? (
        <div className="w-full flex justify-center items-center text-ribola-congress-blue text-center text-base py-2">
          oppure
        </div>
      ) : (
        ""
      );

    divCouponAmbassador = (
      <>
        {perifrasi}
        <CustomButton
          buttonName={riepilogoCarrelloTranslation.utilizzacreditoambassador.itemName.replace(
            "XXX",
            couponAmbassadorValue
          )}
          buttonLink={null}
          buttonOnClickFunction={(event) =>
            onCouponAmbassadorAdd(event, couponAmbassadorValue)
          }
          buttonStyle="w-full flex justify-center items-center text-ribola-congress-blue text-center hover:bg-ribola-web-orange transition duration-300 text-base 2xl:text-md 3xl:text-md font-opensanssemibold py-4 px-2 2xl:px-6 border-2 border-ribola-gallery-gray"
        />
      </>
    );
  }
  // parte coupon
  let divCoupon = "";
  if (
    order?.totalItems > 0 &&
    order?.codiceCoupon === null &&
    routeName === "cartDetail"
  ) {
    divCoupon = (
      <Fragment>
        <InputField
          inputType="text"
          inputLabel={riepilogoCarrelloTranslation.codicesconto.itemName.toUpperCase()}
          inputLabelStyle="text-ribola-congress-blue font-opensansbold mt-5"
          inputName="couponSconto"
          inputValue={couponSconto}
          inputHandlerFunction={onCouponScontoChange}
          inputStyle="border border-ribola-congress-blue border-opacity-100 mt-1 py-2 px-6 text-xl w-full"
        />
        <div className="flex justify-end">
          <span
            onClick={onCouponSend}
            className="buttonBorderedTransparent bg-ribola-congress-blue-variant text-white text-sm text-center w-30 px-5 focus:outline-none"
          >
            {genericheTranslation.invia.itemName}
          </span>
        </div>
      </Fragment>
    );
  } else if (order?.totalItems > 0 && order?.codiceCoupon !== null) {
    divCoupon = (
      <span className="text-ribola-astral text-lg block mt-4">
        {riepilogoCarrelloTranslation.codicesconto.itemName}:
        <strong className="ml-1 max-w-full block overflow-hidden">
          {order.codiceCoupon}
          <small className="ml-1">(-{order.scontoApplicatoCoupon}€)</small>
        </strong>
        <span className="text-red-700">
          <i
            className="fal fa-trash-alt text-2xl cursor-pointer pl-3"
            data-tip={carrelloTranslation.tooltipCancellaCoupon.itemName}
            onClick={() => onAskDeleteCoupon(order?.codiceCoupon)}
          ></i>
        </span>
        <ReactTooltip uuid={`123_cancellaCoupons`} />
      </span>
    );
  }
  // fine parte coupon

  let messagePaypal = "";
  messagePaypal = (
    <>
      {routeName !== "checkoutDetail" ? (
        <PaypalMessages totalePrezzo={totalCart} />
      ) : (
        ""
      )}
    </>
  );

  // disabilito eventi su pulsante quando sto pagando?
  const disablePointerEvents =
    isButtonSending === true || isCouponSending === true
      ? "pointer-events-none"
      : "";

  const aliquotaIVADESC2 =
    aliquotaIVADesc !== "" && "(" + aliquotaIVADesc + ")";

  return (
    <Fragment>
      <span className="text-black text-xl block">
        {riepilogoCarrelloTranslation.totalepeso.itemName}:&nbsp;
        {parseFloat(order.totalWeight).toFixed(2).toString().replace(".", ",")}
        kg
      </span>
      <span className="text-black text-xl block mt-6">
        {riepilogoCarrelloTranslation.imponibile.itemName}:&nbsp;
        <strong>
          {parseFloat(order.subtotalCart)
            .toFixed(2)
            .toString()
            .replace(".", ",")}
          €
        </strong>
        <br />
        <span className="text-sm">
          {riepilogoCarrelloTranslation.ivaimponibile.itemName}&nbsp;
          {parseFloat(subtotalCartVAT).toFixed(2).toString().replace(".", ",")}€
          <small className="ml-2 font-opensanssemibold text-ribola-astral">
            {aliquotaIVADESC2}
          </small>
        </span>
      </span>
      {selezionaSpedizioneORitiroInSede}
      <div className="mt-6">
        {calcoloSpedizione}
        {calcoloSpedizionePerCap}
        <span className="text-black text-xl block mt-4">
          {riepilogoCarrelloTranslation.spedizione.itemName}:&nbsp;
          <strong>
            {parseFloat(shippingCostByWeight)
              .toFixed(2)
              .toString()
              .replace(".", ",")}
            €
          </strong>
          <small className="ml-2 text-xs">{messageRitiroInSede}</small>
          <br />
          <span className="text-sm">
            {riepilogoCarrelloTranslation.ivaspedizione.itemName}&nbsp;
            {parseFloat(shippingCostVATByWeight)
              .toFixed(2)
              .toString()
              .replace(".", ",")}
            €
            <small className="ml-2 font-opensanssemibold text-ribola-astral">
              {aliquotaIVADESC2}
            </small>
          </span>
        </span>
      </div>
      <div className={disablePointerEvents}>
        {divCoupon}
        {divCouponAmbassador}
        <span className="text-ribola-congress-blue font-opensansbold text-2xl 3xl:text-3xl block mt-3 mb-6 2xl:mb-8">
          {riepilogoCarrelloTranslation.totale.itemName.toUpperCase()}:&nbsp;
          {parseFloat(totalCart).toFixed(2).toString().replace(".", ",")} €
        </span>
        {buttonProsegui}
        <div className="w-full my-2">&nbsp;</div>
        {messagePaypal}
      </div>
    </Fragment>
  );
};

export default RiepilogoCarrello;
